import {applyMiddleware, combineReducers, createStore} from 'redux'
import thunk from 'redux-thunk'
import userReducer from './reducers/userReducer'
import appReducer from './reducers/appReducer'
import socialAppReducer from './reducers/socialAppReducer'
import otpAppReducer from './reducers/otpAppReducer'
import broadcastReducer from './reducers/broadcastReducer'

const rootReducer = combineReducers({
  userReducer,
  appReducer,
  otpAppReducer,
  socialAppReducer,
  broadcastReducer
})

const store = createStore(rootReducer, applyMiddleware(thunk))

export default store